import script from "./PromotionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionCard.vue?vue&type=script&setup=true&lang=js"

import "./PromotionCard.vue?vue&type=style&index=0&id=0df82c3c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df82c3c"]])

export default __exports__